export default "__VITE_ASSET__hIG4NRT$__"